import { Component, signal } from '@angular/core';
import { WidgetAccessService } from '@core/services';

@Component({
  selector: 'app-page-issues-dashboard',
  templateUrl: './page-issues-dashboard.component.html',
  styleUrl: './page-issues-dashboard.component.scss',
  standalone: false,
})
export class PageIssuesDashboardComponent {
  hasAccesOnlyToProductLinks = signal<boolean>(this.widgetAccessService.hasAccesOnlyToProductLinks());

  constructor(private readonly widgetAccessService: WidgetAccessService) {}
}
